import { type FC, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import { type Decision } from '@editor2/types/pageElements';
import { updateElement } from '@editor2/reducers/editor/editorSlice';
import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';
import { elementCommonStyles } from '@editor2/styles/element';

interface Props {
	element: Decision;
	courseId: number;
}

const DecisionElement: FC<Props> = (props) => {
	const { element, courseId } = props;

	const commonPayload = { elementId: element.family_id, courseId };

	const debouncedDispatch = useDebouncedDispatch();

	const [name, setName] = useState(element.name);
	const [prompt, setPrompt] = useState(element.prompt);

	useEffect(() => {
		if (element.name !== name) {
			setName(element.name);
		}

		if (element.prompt !== prompt) {
			setPrompt(element.prompt);
		}
	}, [element]);

	return (
		<Form className={elementCommonStyles}>
			<Form.Group>
				<Form.Label>Name</Form.Label>
				<Form.Control
					value={name}
					placeholder="Name"
					onChange={(e) => {
						setName(e.target.value);
						debouncedDispatch(updateElement({ ...commonPayload, name: e.target.value }));
					}}
				/>
			</Form.Group>

			<Form.Group>
				<Form.Label>Prompt</Form.Label>
				<Form.Control
					as="textarea"
					rows={3}
					value={prompt}
					placeholder="Prompt"
					onChange={(e) => {
						setPrompt(e.target.value);
						debouncedDispatch(updateElement({ ...commonPayload, prompt: e.target.value }));
					}}
				/>
			</Form.Group>
		</Form>
	);
};

export default DecisionElement;
